// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"52":"128c10e01840d178","341":"41fa1cb6038b2ed6","388":"46cd509de26ebf2a","558":"ae2126d2667b0925","562":"b640a55c239b405a","826":"f3f5fedb7a71c54a","859":"b64ff318c21495fc","954":"a6aab673293c0ed6"}[chunkId] + ".js";
};